import React from 'react';

export function GalleryPage({ onBook }: { onBook: () => void }) {
  const images = [
    { src: "https://lh3.googleusercontent.com/p/AF1QipOGZCkz24SUGKCNlO9KtphhvCPV8KIgcCnLvog2=w244-h408-n-k-no-nu", title: "Hair Styling" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipMANZx9Ck83hxT_Cb0T8_5iyuOFpd4O50hmaPKC=s680-w680-h510", title: "Lash Extensions" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipNABHS7oTFMYfjIoUN708g4MwNvmxBeDMVSyP_3=s680-w680-h510", title: "Premium Facials" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipOZH-qc9OHgHTyjikwbBmdPleYVDpp1UVQieRkX=s680-w680-h510", title: "Nail Artistry" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipO1E4QxDvSjx_ofQYT3M65x79nbjP75-8fFAo_n=s680-w680-h510", title: "Bridal Prep" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipN1uzHUQ8T9PxshDBzCospPDgGLIU19jzU9r1CV=s680-w680-h510", title: "Balayage" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipO0gi_0_HDQlMMJOxdT59W8A10pmnorCdwEHfLS=s680-w680-h510", title: "Skincare" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipM1c2R8hS0W13Svet20CSJXNAiS0VfwMc5QbImi=s680-w680-h510", title: "Color Correction" },
    { src: "https://lh3.googleusercontent.com/p/AF1QipMnkaBVVpE-2pQMWYXz0TmcYej5nnG_MK_T5ufd=s680-w680-h510", title: "Luxury Manicure" }
  ];

  return (
    <div className="bg-stone-50 min-h-screen pt-32 pb-24 px-6 relative z-10">
      <div className="max-w-6xl mx-auto">
        <h1 className="font-serif text-5xl md:text-7xl text-mier font-light mb-12 text-center fade-in-up">Abu Dhabi Salon Gallery</h1>
        <div className="w-px h-12 bg-mier-light/30 mx-auto mb-16 scale-y-animation"></div>
        <p className="max-w-3xl mx-auto mb-12 text-center text-sm text-stone-600 leading-relaxed font-light fade-in-up">
          Explore real work from MIER Beauty Lounge in Al Rawdah, Abu Dhabi, including balayage, lash extensions, gel nails, facials, bridal prep, and premium salon finishing.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((img, i) => (
            <div key={i} className="aspect-[4/5] overflow-hidden bg-stone-200 fade-in-up group relative cursor-pointer">
              <img 
                src={img.src} 
                alt={`${img.title} service at MIER Beauty Lounge Abu Dhabi`} 
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 ease-out" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-mier-dark/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-8">
                <span className="text-stone-50 font-serif text-2xl drop-shadow-md">{img.title}</span>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-32 text-center fade-in-up border-t border-mier-light/20 pt-20">
          <h2 className="font-serif text-4xl mb-8 font-light">Inspired by our work?</h2>
          <button 
            onClick={onBook}
            className="inline-flex items-center gap-3 bg-mier text-stone-50 px-10 py-5 text-sm tracking-[0.2em] uppercase hover:bg-mier-dark hover:text-stone-50 transition-all duration-300 shadow-xl"
          >
            Get Your Look Today
          </button>
        </div>
      </div>
    </div>
  );
}
